import type { Program, Wallet } from "@coral-xyz/anchor";
import type { Connection } from "@solana/web3.js";
import type { RewardCallOptionsIDL } from "@stepfinance/common";
import { makeAnchorProgram, RewardCallOptionsJSON } from "@stepfinance/common";

export const REWARD_OPTIONS_PROGRAM_ID = "RopsJ74nrtcsk9iND8CFFNjn5mxf1tFzF3RhMPJ3CdV";

export const getStepRewardOptionsProgram = (connection: Connection, wallet?: Wallet): Program<RewardCallOptionsIDL> =>
  makeAnchorProgram(RewardCallOptionsJSON, connection, {
    programId: REWARD_OPTIONS_PROGRAM_ID,
    wallet,
  });
